import { pathOr, equals, includes } from 'ramda';
import { isNotEmpty } from 'src/utilities/hasValue';

export const formattedActiveAnswer = (intent: any) => {
  const answer = pathOr('', ['answer'], intent)
  const metadata = pathOr('', ['metadata'], intent);
  const needToParse = isNotEmpty(answer) &&
    equals(pathOr('', ['type'], metadata), 'Object') &&
    !includes(answer, ['-', 'none'])
  try {
    return needToParse ? JSON.parse(answer) : answer
  } catch {
    return answer
  }
}
